/* =========================================================================
   aw-v2-buy.js — zone d'achat de la fiche produit.

   POURQUOI CE FICHIER EXISTE
   Le bundle prakt (assets/app.js, sources absentes) porte une classe de
   gestion des variantes qui ne s'initialise jamais. Sa garde
   `get_data.length > 0` échoue à la construction, si bien que
   `selected_options` n'est jamais affecté. Or le gestionnaire du bouton
   « Ajouter au panier », lui, s'attache bien — et la première chose qu'il
   fait est de déréférencer ce binding. Au clic, la console affiche :

       Uncaught ReferenceError: Cannot access 'Br' before initialization

   C'est une zone morte temporelle (un `const`/`let` du bundle référencé
   avant son initialisation). Conséquences observées sur le thème LIVE comme
   sur le dev, sur une fiche 3 options comme sur une fiche 2 options :
     — cliquer une option ne fait rien : ni sélection, ni prix, ni variante ;
     — cliquer « Ajouter au panier » ne fait rien : le panier reste vide ;
     — le prix affiché est le minimum catalogue, pas celui de la variante.
   Seul le paiement express, natif Shopify, permettait encore d'acheter — sur
   la variante par défaut uniquement.

   Ce fichier reprend donc la logique d'achat à son compte, sans rien attendre
   du bundle. Il est VOLONTAIREMENT séparé de aw-v2-product.js : celui-ci
   porte les comportements des sections v2 (supports, atelier, sélection),
   qui n'ont rien à voir avec l'achat et n'ont pas à partir en correctif.

   CE QU'IL NE FAIT PAS
   Il ne touche ni à la galerie, ni au zoom, ni aux tiroirs, ni au panneau
   panier : ces parties d'app.js fonctionnent et restent en place. Le contrat
   `.related_products` de aw-v2-selection n'est pas concerné.
   ========================================================================= */
(function () {
  'use strict';

  function demarrer() {
    var liste = document.querySelector('.variant_list');
    if (!liste) return;

    var groupes = Array.prototype.slice.call(document.querySelectorAll('.variant_group'))
      .sort(function (a, b) { return Number(a.dataset.id) - Number(b.dataset.id); });
    if (!groupes.length) return;

    /* Les variantes viennent des <span> de données rendus par aw-product.liquid.
       On lit des attributs par option (data-o1/2/3) plutôt que de découper
       `variant.title` sur « / » : une valeur d'option contenant une barre
       oblique casserait silencieusement le découpage, et c'est le chemin
       d'achat qui en dépendrait. */
    var variantes = Array.prototype.slice.call(liste.querySelectorAll('.aw-variant')).map(function (s) {
      return {
        id: s.dataset.id,
        o: [s.dataset.o1 || '', s.dataset.o2 || '', s.dataset.o3 || ''],
        prix: s.dataset.prix || '',
        compare: s.dataset.compare || '',
        remise: s.dataset.remise || '',
        dispo: s.dataset.dispo === '1'
      };
    });
    if (!variantes.length) return;

    var nb = groupes.length;
    var selection = [];
    var bouton = document.querySelector('#AddToCart');

    function boutonsDe(g) {
      return Array.prototype.slice.call(groupes[g].querySelectorAll('.variant_button'));
    }

    /* Une valeur est proposable s'il existe au moins une variante DISPONIBLE
       qui la porte, compte tenu des choix déjà faits à sa gauche. Cascade de
       gauche à droite : en avançant, on ne tombe jamais sur un cul-de-sac. */
    function possible(g, valeur) {
      for (var k = 0; k < variantes.length; k++) {
        var v = variantes[k];
        if (!v.dispo || v.o[g] !== valeur) continue;
        var ok = true;
        for (var i = 0; i < g; i++) {
          if (selection[i] && v.o[i] !== selection[i]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }

    function resoudre() {
      for (var i = 0; i < nb; i++) if (!selection[i]) return null;
      for (var k = 0; k < variantes.length; k++) {
        var v = variantes[k], ok = true;
        for (var j = 0; j < nb; j++) if (v.o[j] !== selection[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    /* Après un changement à gauche, une valeur choisie à droite peut être
       devenue impossible. On la remplace par la première valeur encore
       proposable, plutôt que de laisser l'internaute devant un formulaire
       incohérent qui refuserait l'ajout sans dire pourquoi. */
    function reparer(depuis) {
      for (var i = depuis; i < nb; i++) {
        if (selection[i] && possible(i, selection[i])) continue;
        var libres = boutonsDe(i).filter(function (b) { return possible(i, b.dataset.value); });
        selection[i] = libres.length ? libres[0].dataset.value : null;
      }
    }

    function peindre() {
      for (var g = 0; g < nb; g++) {
        // forEach est synchrone : `rang` et `courant` valent bien ce qu'il faut
        // au moment de l'appel, sans avoir à jouer avec le `this` du callback.
        var rang = g;
        var courant = selection[g];
        boutonsDe(g).forEach(function (b) {
          var val = b.dataset.value;
          var off = !possible(rang, val);
          b.classList.toggle('disabled', off);
          b.setAttribute('aria-disabled', off ? 'true' : 'false');
          b.classList.toggle('active', courant === val);
        });
      }
    }

    function majPrix(v) {
      var bloc = document.querySelector('.price_container');
      if (!bloc || !v) return;
      var fin = bloc.querySelector('.price .final');
      var comp = bloc.querySelector('.compare_at_price');
      var rem = bloc.querySelector('.discount');
      if (fin) fin.textContent = v.prix;
      if (comp) { comp.textContent = v.compare; comp.hidden = !v.compare; }
      if (rem) { rem.textContent = v.remise ? '-' + v.remise + '%' : ''; rem.hidden = !v.remise; }
      if (v.prix) bloc.setAttribute('data-price', v.prix);
    }

    function majFormulaire(v) {
      var cache = document.querySelector('#variant_id');
      var select = document.querySelector('#variant_selector');
      if (cache) cache.value = v ? v.id : '';
      if (select && v) select.value = v.id;
    }

    function rafraichir() {
      peindre();
      var v = resoudre();
      majPrix(v);
      majFormulaire(v);
      if (bouton) {
        var impossible = !v || !v.dispo;
        bouton.classList.toggle('disabled', impossible);
        bouton.setAttribute('aria-disabled', impossible ? 'true' : 'false');
      }
    }

    /* ---------- Compteur du header ----------
       Il est écrit en dur dans aw-header.liquid (« 02 ») et le bundle ne le
       met jamais à jour. On le corrige après un ajout, sinon le seul retour
       visuel serait le libellé du bouton. */
    function majCompteur() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var el = document.querySelector('.cart_button .counter');
          if (el) el.textContent = (c.item_count < 10 ? '0' : '') + c.item_count;
        })
        .catch(function () { /* le compteur reste tel quel : sans conséquence */ });
    }

    /* Le panneau panier volant est court-circuite : le bouton du header est
       desormais un lien direct vers /cart (voir snippets/aw-header.liquid).
       On ne cherche donc plus a l'ouvrir — apres « Ajoute ✓ », le clic suivant
       sur l'icone panier mene a une page reelle au lieu d'un tiroir vide. */

    function ajouter(e) {
      /* Les deux coupures d'abord, AVANT toute sortie anticipee : meme si l'on
         renonce a ajouter, l'ecouteur d'app.js ne doit pas prendre le relais. */
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!bouton || bouton.dataset.enCours === '1') return;
      var v = resoudre();
      if (!v) return flash('Choisissez une option');
      if (!v.dispo) return flash('Épuisé');

      var q = document.querySelector('#Quantity');
      var quantite = Math.max(1, Number(q && q.value) || 1);
      var libelle = bouton.textContent;
      bouton.dataset.enCours = '1';
      bouton.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(v.id), quantity: quantite })
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j && j.description ? j.description : 'Ajout refusé');
            return j;
          });
        })
        .then(function () {
          bouton.textContent = 'Ajouté ✓';
          majCompteur();
          setTimeout(function () {
            bouton.textContent = libelle;
            delete bouton.dataset.enCours;
          }, 2500);
        })
        .catch(function (err) {
          bouton.textContent = libelle;
          delete bouton.dataset.enCours;
          flash(err.message || 'Ajout refusé');
        });
    }

    function flash(message) {
      if (!bouton) return;
      var libelle = bouton.dataset.libelle || bouton.textContent;
      bouton.dataset.libelle = libelle;
      bouton.textContent = message;
      setTimeout(function () { bouton.textContent = libelle; }, 1800);
    }

    /* ---------- Branchements ---------- */
    groupes.forEach(function (groupe, g) {
      groupe.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.variant_button') : null;
        if (!b || !groupe.contains(b)) return;
        // Le grisage doit tenir au clic, pas seulement à l'œil : app.css pose
        // `pointer-events: none` sur .disabled, ce qui n'arrête ni le clavier
        // ni un clic programmatique.
        if (b.classList.contains('disabled')) return;
        selection[g] = b.dataset.value;
        reparer(g + 1);
        rafraichir();
      });
    });

    if (bouton) {
      /* NEUTRALISATION DE L'ECOUTEUR DU BUNDLE — par ordre d'enregistrement.

         Ce fichier est charge en `defer` dans le <head>, app.js en `defer` en
         fin de <body>. Les scripts differes s'executent dans l'ordre du
         document : NOTRE ecouteur est donc enregistre EN PREMIER. Sur un meme
         noeud, les ecouteurs partent dans l'ordre d'enregistrement, et
         stopImmediatePropagation() interrompt la serie — celui d'app.js n'est
         jamais appele.

         La version precedente clonait le bouton pour « detacher » l'ecouteur du
         bundle. Elle faisait l'inverse de ce qu'on croyait : au moment du
         clonage, app.js n'avait pas encore pose son ecouteur. Il le posait
         ensuite sur le clone, et les deux gestionnaires ajoutaient au panier —
         un clic, deux articles. Le defaut n'est apparu qu'en production, parce
         que sur le dev le gestionnaire du bundle mourait avant d'ajouter. */
      bouton.addEventListener('click', ajouter);
    }

    /* État de départ : on aligne l'affichage sur la variante que Shopify a
       réellement chargée dans le formulaire, au lieu de laisser un formulaire
       vierge en face d'un prix minimum catalogue. */
    var depart = null;
    var cache = document.querySelector('#variant_id');
    if (cache && cache.value) {
      depart = variantes.filter(function (v) { return v.id === String(cache.value); })[0] || null;
    }
    if (!depart) depart = variantes.filter(function (v) { return v.dispo; })[0] || null;
    if (depart) for (var i = 0; i < nb; i++) selection[i] = depart.o[i];
    reparer(0);
    rafraichir();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
